<template>
  <el-dialog
    class="base-dialog"
    :title="undefined"
    :show-close="true"
    :close-on-click-modal="true"
    :visible="visible"
    :width="isDesktop ? '60%' : '90%'"
    :modal-append-to-body="false"
    :modal="false"
    @close="onClose">
    <div class="el-dialog__content" style="max-width:930px;margin-left:auto;margin-right:auto;text-align:center;">
      <slot></slot>
    </div>
    <span slot="footer" class="dialog-footer" align="center" v-if="!noFooter">
      <div class="button is-primary" style="margin-bottom:15px;margin-right:-10px;" @click="onClose">
        <span style="text-transform:uppercase;">Close</span>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import EventBus from '@/controllers/EventBus'
export default {
  name: 'MainDialog',
  props: ['visible', 'no-footer'],
  data () {
    return {
      isDesktop: true
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
    onClose () {
      this.$emit('onClose')
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.base-dialog {
  .el-dialog {
    margin-top: 8vh !important;
  }
  .el-dialog__headerbtn {
    top: 10px;
    right: 13px;
  }
  .el-dialog__body {
    padding: 10px 30px 30px;
  }
  .el-dialog__footer {
    text-align: center;
  }
}

</style>



// WEBPACK FOOTER //
// Dialog.vue?46145a10